// extracted by mini-css-extract-plugin
module.exports = {"carousel":"PDnmYj","container":"Qsf3nF"};